<template lang="pug">
  .partner.container(:class="englishVersion || mexicoVersion ? 'mt-0' : ''")
      .partner__content
          .partner__title
              span(v-html="tr.partner.title")
          img.partner__mobileImg(src=`../../../assets/images/partner_img.png`, alt="" v-if="!englishVersion && !mexicoVersion")
          img.partner__mobileImg(src=`../../../assets/images/partner_img_en.png`, alt="" v-if="englishVersion || mexicoVersion")
          .partner__dsc
              span(v-html="tr.partner.dsc")
          EditableBlock(
            :text="tr.partner.btn"
            :field="'partner.btn'"
            section="main"
          )
            vButton.is__btn.partner__btn( large to="inside-team" ) {{ tr.partner.btn }}

      img.partner__imgs(src=`../../../assets/images/partner_img.png`, alt="" v-if="!englishVersion && !mexicoVersion")
      img.partner__imgs(src=`../../../assets/images/partner_img_en.png`, alt="" v-if="englishVersion || mexicoVersion")
</template>

<script>
import vButton from '../../elements/vButton'
import EditableBlock from '../EditableBlock'
import langOps from '@/mixins/langOps'

export default {
  components: {
    vButton,
    EditableBlock
  },
  data () {
    return {
      section: 'main'
    }
  },
  mixin: [langOps]
}
</script>

<style lang="scss">
  .partner.mt-0{
    margin-top: 0 !important;
  }
  @import './style.scss';
</style>
